// gsap is a global from PHP-enqueued vendor scripts

export function initAccordion() {
    const accordionItems = document.querySelectorAll(".content-item");
    if (!accordionItems.length) return;

    accordionItems.forEach((item) => {
        const header  = item.querySelector(".accordion-header");
        const content = item.querySelector(".accordion-content");

        if (!header || !content || header.dataset.accordionInitialized) return;
        header.dataset.accordionInitialized = true;

        gsap.set(content, { height: 0, overflow: "hidden" });

        header.addEventListener("click", () => {
            const isActive = item.classList.contains("active");

            accordionItems.forEach((i) => {
                i.classList.remove("active");
                gsap.to(i.querySelector(".accordion-content"), {
                    height: 0,
                    duration: 0.4,
                    ease: "power2.inOut",
                });
            });

            if (!isActive) {
                item.classList.add("active");
                gsap.to(content, {
                    height: content.scrollHeight,
                    duration: 0.4,
                    ease: "power2.out",
                });
            }
        });
    });
}
